import React, { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import baseUrl from "../../../../../api/baseUrl";
import CloseIcon from "@mui/icons-material/Close";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

function AddSupplier({ closeModal, id }: any) {
  const methods = useForm();

  const onSubmit = (data: any) => {
    if (id) {
      baseUrl
        .patch("client/inventory/supplier/updateSupplierById", data, {
          headers: { supplierid: id },
        })
        .then(() => {
          methods.reset();
          closeModal();
        })
        .catch((error) => console.error(error?.response));
    } else {
      baseUrl
        .post("client/inventory/supplier/createSupplier", data)
        .then(() => {
          methods.reset();
          closeModal();
        })
        .catch((error) => console.error(error?.response));
    }
  };

  const getSupplierData = (id: any) => {
    baseUrl
      .get("client/inventory/supplier/findSupplierById", {
        headers: { supplierid: id },
      })
      .then((response) => methods.reset(response.data.data))
      .catch((error) => console.error(error?.response));
  };

  useEffect(() => {
    if (id) getSupplierData(id);
  }, [id]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-[8px] shadow-2xl w-full max-w-md overflow-hidden">
        {/* Header */}
        <div className="px-3 py-2 border-b border-slate-200 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 bg-amber-100 rounded-md flex items-center justify-center">
              <LocalShippingIcon className="text-amber-600" sx={{ fontSize: 14 }} />
            </div>
            <h2 className="text-xs font-bold text-slate-800">
              {id ? "Edit Supplier" : "Add Supplier"}
            </h2>
          </div>
          <button
            onClick={closeModal}
            className="w-6 h-6 rounded-md bg-slate-100 hover:bg-slate-200 flex items-center justify-center text-slate-600 transition-colors"
          >
            <CloseIcon sx={{ fontSize: 14 }} />
          </button>
        </div>

        {/* Form */}
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <div className="p-3 space-y-3">
              <div>
                <label className="block text-xs font-medium text-slate-700 mb-1">
                  <div className="flex items-center gap-1">
                    <BusinessIcon sx={{ fontSize: 14 }} />
                    Company Name
                  </div>
                </label>
                <input
                  {...methods.register("suppliercompany")}
                  type="text"
                  placeholder="Enter company name"
                  className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-xs"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-slate-700 mb-1">
                  <div className="flex items-center gap-1">
                    <PersonIcon sx={{ fontSize: 14 }} />
                    Supplier Name
                  </div>
                </label>
                <input
                  {...methods.register("supplierName")}
                  type="text"
                  placeholder="Enter supplier name"
                  className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-xs"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-slate-700 mb-1">
                  <div className="flex items-center gap-1">
                    <EmailIcon sx={{ fontSize: 14 }} />
                    Email
                  </div>
                </label>
                <input
                  {...methods.register("email")}
                  type="email"
                  placeholder="Enter email"
                  className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-xs"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-slate-700 mb-1">
                  <div className="flex items-center gap-1">
                    <PhoneIcon sx={{ fontSize: 14 }} />
                    Contact Number
                  </div>
                </label>
                <input
                  {...methods.register("phoneNumber")}
                  type="text"
                  placeholder="Enter contact number"
                  className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-xs"
                />
              </div>
            </div>

            {/* Footer */}
            <div className="px-3 py-2 border-t border-slate-200 flex justify-end gap-2">
              <button
                type="button"
                onClick={closeModal}
                className="px-4 py-2.5 text-slate-600 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors font-medium text-xs"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg hover:shadow-lg hover:shadow-primary/20 transition-all font-medium text-xs"
              >
                {id ? "Update" : "Submit"}
              </button>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
}

export default AddSupplier;
